<template>
  <div>
    <div class="ccui-app-container-detail2">
      <div ref="detailBody" class="ccui-app-container-detail-body">
        <div style="margin-bottom: 10px" v-if="bidPriceStatus == '0'">
          <!-- 抱歉，该环节尚未开始 -->
          <el-alert
            class="alertColor"
            :title="$t('page.content.Noyet1')"
            type="warning"
            :closable="false"
            show-icon
          >
          </el-alert>
        </div>
        <div style="margin-bottom: 15px">
          <!-- 请您按照报价要求填报报价信息及上传投标文件 -->

          <el-alert
            class="alertColor"
            v-if="bidPriceStatus == '2'"
            :title="$t('page.content.requirements')"
            type="warning"
            :closable="false"
            show-icon
          >
          </el-alert>
          <!-- 无法查看 -->
          <el-alert
            class="alertColor"
            v-if="bidPriceStatus == '3'"
            :title="$t('page.content.unableToView')"
            type="warning"
            :closable="false"
            show-icon
          >
          </el-alert>

          <!-- 上轮报价已结束 -->
          <el-alert
            class="alertColor"
            v-if="bidPriceStatus == '1'"
            :title="$t('page.content.over')"
            type="warning"
            :closable="false"
            show-icon
          >
          </el-alert>
          <!-- <el-alert
            class="alertColor"
            v-if="flag == 1 || flag == 3"
            title="本次投标已经结束，投标记录已被锁定，投标信息不能进行变更"
            type="warning"
            :closable="false"
            show-icon
          >
          </el-alert> -->
        </div>
        <!-- 投标要求和说明      投标要求-->
        <div
          v-if="bidPriceStatus == '1' || bidPriceStatus == '2'"
          class="historyPrice"
        >
          <!--历史报价记录：-->
          <!--请选择-->
          <span class="title">{{
            `${$t("page.content.historicalQuotationRecord")}：`
          }}</span>
          <el-select
            v-model="bidPriceId"
            :placeholder="$t('page.content.pleaseChoose')"
            @change="changeBidPrice"
          >
            <el-option
              v-for="item in bidPriceOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </div>
        <el-group-title
          :title="
            flag == 1 ? $t('page.content.Title1') : $t('page.content.Title2')
          "
          v-if="flag != 0 && flag != 2 && bidFlag != 4 && bidFlag !== ''"
        >
          <template slot="groupTitle">
            <div class="tip">
              <!-- 标题： -->
              <p class="tip-title">
                {{ $t("page.content.Title") }}：{{ sscNoticeBO.noticeTitle }}
              </p>
              <!-- 说明： -->
              <p>
                {{ $t("page.content.Remarks") }}：<span
                  class="content-remark rich-text"
                  v-html="sscNoticeBO.textInfo"
                ></span>
              </p>
            </div>
          </template>
        </el-group-title>
        <!-- 附件列表 -->
        <detailBaseTable
          v-if="bidPriceStatus == '1' || bidPriceStatus == '2'"
          :title="$t('page.content.attachments')"
          :table-head="tableChangeHistoryHead"
          :table-data="tableChangeHistoryData"
        >
          <!-- 操作 -->
          <template
            :slot="$t('page.content.operation')"
            slot-scope="{ row, $index }"
          >
            <el-button
              size="mini"
              type="text"
              @click="downloadUrlFile(row, $index)"
            >
              <!-- 下载 -->
              {{ $t("page.content.Download") }}
            </el-button>
            <!-- 预览 -->
            <el-button size="mini" type="text" @click="preview(row)">
              {{ $t("page.content.Yulan") }}
            </el-button>
          </template>
        </detailBaseTable>

        <!-- 未投标 -->
        <div
          class="noBuy"
          v-if="bidPriceStatus == '1' || bidPriceStatus == '2'"
        >
          <!--报价总金额： 元   整-->
          <div class="noBuyTop">
            <span class="priceBox" style="color: red">
              {{ `${$t("page.content.totalQuotedAmount")}：`
              }}{{ totalPrice | coinFormat2("0", true) }}（{{
                unit ? unit : $t("page.content.yuan")
              }}）{{
                totalPrice &&
                totalPrice.toString().indexOf(".") !== -1 &&
                totalPrice.split(".")[1] - 0 == 0
                  ? $t("page.content.whole")
                  : ""
              }}</span
            >
            <el-tabs class="el-tabs__customize" value="1">
              <!--报价清单-->
              <el-tab-pane name="1" :label="$t('page.content.quotationList')">
                <tableBid
                  @setTotalPrice="setTotalPrice"
                  ref="tableBid"
                  :tableData="tableBid"
                  :unit="unit"
                  :fixedTax="fixedTax"
                  :isBid="false"
                  :invoiceType="invoiceType"
                  :isUnitPriceTax="isUnitPriceTax"
                  :isTaxAmount="isTaxAmount"
                  :subPackageFlag="subPackageFlag"
                  :bidPriceStatus="bidPriceStatus"
                  :type="bidPriceStatus == '2' && bidFlag == 0 ? 1 : 0"
                ></tableBid>
              </el-tab-pane>
            </el-tabs>
          </div>

          <div class="upFile">
            <!--项目负责人-->
            <el-tabs class="el-tabs__customize" value="1">
              <el-tab-pane name="1" :label="$t('page.content.projectLeader')">
                <el-tabs
                  class="customeTab"
                  v-model="active1"
                  v-if="subPackageFlag == 1"
                >
                  <!--（已流标）-->
                  <el-tab-pane
                    v-for="(listItem, listIndex) in tableBid"
                    :key="listIndex"
                    :label="
                      listItem.packName +
                        (listItem.packStatus == '2'
                          ? $t('page.content.droppedMark')
                          : '')
                    "
                    :name="listIndex + ''"
                  >
                    <!--添加项目负责人-->
                    <userList
                      :titles="$t('page.content.addProjectLeader')"
                      :noDisabled="bidPriceStatus == '2' && bidFlag == 0"
                      :extTable="tableBid[active1].projectPersons || []"
                      ref="projectPersons"
                    ></userList>
                  </el-tab-pane>
                </el-tabs>
                <!---->
                <userList
                  v-else
                  :titles="$t('page.content.addProjectLeader')"
                  :noDisabled="bidPriceStatus == '2' && bidFlag == 0"
                  :extTable="tableBid[active1].projectPersons || []"
                  ref="projectPersons"
                ></userList>
              </el-tab-pane>
            </el-tabs>
          </div>

          <div class="upFile">
            <el-tabs class="el-tabs__customize" value="1">
              <!--技术负责人-->
              <el-tab-pane
                name="1"
                :label="$t('page.content.technicalDirector')"
              >
                <el-tabs
                  class="customeTab"
                  v-model="active2"
                  v-if="subPackageFlag == 1"
                >
                  <!--（已流标）-->
                  <el-tab-pane
                    v-for="(listItem, listIndex) in tableBid"
                    :key="listIndex"
                    :label="
                      listItem.packName +
                        (listItem.packStatus == '2'
                          ? $t('page.content.droppedMark')
                          : '')
                    "
                    :name="listIndex + ''"
                  >
                    <!--添加技术负责人-->
                    <userList
                      :titles="$t('page.content.addTechnicalLeader')"
                      :extTable="tableBid[active2].techPersons || []"
                      :noDisabled="bidPriceStatus == '2' && bidFlag == 0"
                      ref="techPersons"
                    ></userList>
                  </el-tab-pane>
                </el-tabs>
                <!--添加技术负责人-->
                <userList
                  v-else
                  :titles="$t('page.content.addTechnicalLeader')"
                  :extTable="tableBid[active2].techPersons || []"
                  :noDisabled="bidPriceStatus == '2' && bidFlag == 0"
                  ref="techPersons"
                ></userList>
              </el-tab-pane>
            </el-tabs>
          </div>

          <div class="upFile">
            <el-tabs class="el-tabs__customize" value="1">
              <!--安全负责人-->
              <el-tab-pane name="1" :label="$t('page.content.safetyManager')">
                <el-tabs
                  class="customeTab"
                  v-model="active3"
                  v-if="subPackageFlag == 1"
                >
                  <!--（已流标）-->
                  <el-tab-pane
                    v-for="(listItem, listIndex) in tableBid"
                    :key="listIndex"
                    :label="
                      listItem.packName +
                        (listItem.packStatus == '2'
                          ? $t('page.content.droppedMark')
                          : '')
                    "
                    :name="listIndex + ''"
                  >
                    <!--添加安全负责人-->
                    <userList
                      :titles="$t('page.content.addASecurityPrincipal')"
                      :extTable="tableBid[active3].securityPersons || []"
                      :noDisabled="bidPriceStatus == '2' && bidFlag == 0"
                      ref="securityPersons"
                    ></userList>
                  </el-tab-pane>
                </el-tabs>
                <!--添加安全负责人-->
                <userList
                  v-else
                  :titles="$t('page.content.addASecurityPrincipal')"
                  :extTable="tableBid[active3].securityPersons || []"
                  :noDisabled="bidPriceStatus == '2' && bidFlag == 0"
                  ref="securityPersons"
                ></userList>
              </el-tab-pane>
            </el-tabs>
          </div>

          <div class="upFile">
            <el-tabs class="el-tabs__customize" value="1">
              <!--其他人员-->
              <el-tab-pane name="1" :label="$t('page.content.otherPersonnel')">
                <el-tabs
                  class="customeTab"
                  v-model="active4"
                  v-if="subPackageFlag == 1"
                >
                  <!--（已流标）-->
                  <el-tab-pane
                    v-for="(listItem, listIndex) in tableBid"
                    :key="listIndex"
                    :label="
                      listItem.packName +
                        (listItem.packStatus == '2'
                          ? $t('page.content.droppedMark')
                          : '')
                    "
                    :name="listIndex + ''"
                  >
                    <!--添加其他人员-->
                    <userList
                      :titles="$t('page.content.addOtherPeople')"
                      :extTable="tableBid[active4].otherPersons || []"
                      :noDisabled="bidPriceStatus == '2' && bidFlag == '0'"
                      ref="otherPersons"
                    ></userList>
                  </el-tab-pane>
                </el-tabs>
                <!--添加其他人员-->
                <userList
                  v-else
                  :titles="$t('page.content.addOtherPeople')"
                  :extTable="tableBid[active4].otherPersons || []"
                  :noDisabled="bidPriceStatus == '2' && bidFlag == '0'"
                  ref="otherPersons"
                ></userList>
              </el-tab-pane>
            </el-tabs>
          </div>

          <div class="upFile">
            <el-tabs class="el-tabs__customize" value="1">
              <!--附件信息-->
              <el-tab-pane
                name="1"
                :label="$t('page.content.attachmentInformation')"
              >
                <el-tabs
                  class="customeTab"
                  v-model="active"
                  v-if="subPackageFlag == 1"
                >
                  <el-tab-pane
                    v-for="(listItem, listIndex) in tableBid"
                    :key="listIndex"
                    :label="listItem.packName"
                    :name="listIndex + ''"
                  >
                    <!-- 上传投标文件 -->
                    <attachmentUpload
                      ref="fileTable"
                      :fileData="tableBid[active].sscPurchaseFileBOS"
                      :type="bidPriceStatus == '2' && bidFlag == 0 ? 1 : 2"
                      :style="{
                        marginTop: flag == 1 && bidFlag != 2 ? '0px' : '20px'
                      }"
                      @setFileUploadData="setFileUploadData"
                    ></attachmentUpload>
                    <!-- 请上传投标文件，大小应该控制在30M内 -->
                    <!-- <span :style="{ left: spanWidth + 'px' }">{{
                  $t("page.content.message")
                }}</span> -->
                  </el-tab-pane>
                </el-tabs>
                <attachmentUpload
                  v-else-if="tableBid[active]"
                  ref="fileTable"
                  :fileData="tableBid[active].sscPurchaseFileBOS"
                  :type="flag == 3 && bidFlag == 0 ? 1 : 2"
                  style="margin-top: 20px"
                  @setFileUploadData="setFileUploadData"
                ></attachmentUpload>
              </el-tab-pane>
            </el-tabs>
          </div>
        </div>
        <!-- 投标确认 -->
        <el-dialog
          width="500px"
          :title="this.$t('page.content.bidConfirmation')"
          :visible.sync="dialogTableVisibletextarea"
          center
        >
          <div class="dialogBid">
            <div v-if="purchaseType != 50 && purchaseType != 53">
              <!-- 投标总金额（元）： -->
              <p v-for="item in packNameList" :key="item.packId">
                <span class="item-packName">{{ item.packName }}</span
                >{{ $t("page.content.Totalamount") + "(" + unit + ")" }}：<span
                  style="color: red"
                  >{{ item.packPriceAmount | bigNumberFormat(8) }}</span
                >
              </p>
              <!-- 本次报价总金额（元）： -->
              <p>
                {{ $t("page.content.this")
                }}{{ $t("page.content.Totalamount") + "(" + unit + ")" }}：<span
                  style="color: red"
                  >{{ totalPrice | bigNumberFormat(8) }}</span
                >
              </p>
              <!-- 大写金额：   整-->
              <p>
                {{ $t("page.content.AmountInWords") }}：<span
                  >{{ totalPrice | coinFormat2("0", true)
                  }}{{
                    unit +
                      (totalPrice && Math.ceil(totalPrice) == totalPrice
                        ? $t("page.content.whole")
                        : "")
                  }}</span
                >
              </p>
            </div>
            <!-- 您是否确认提交？ -->
            <p>{{ $t("page.content.suresubmit") }}</p>
          </div>
          <div slot="footer" class="dialog-footer">
            <!-- 取 消 -->
            <el-button
              size="mini"
              type="default-mini"
              @click="dialogTableVisibletextarea = false"
              >{{ $t("page.content.cancel") }}</el-button
            >
            <!-- 确 定 -->
            <el-button
              size="mini"
              type="primary-font-mini"
              :disabled="btnDisabled"
              @click="sure"
              >{{ $t("page.content.sure1") }}</el-button
            >
          </div>
        </el-dialog>
      </div>
    </div>
    <!-- 可以报价 -->
    <div
      class="operate"
      :style="{ width: width }"
      v-if="bidPriceStatus == '2' && bidFlag == '0'"
    >
      <!-- 提交 -->
      <el-button
        type="text"
        icon="icon-ccui-agree"
        @click="submit"
        :disabled="tableBid.length == 0"
      >
        <!--上报-->
        {{ $t("page.content.report") }}
      </el-button>
    </div>

    <div
      class="operate"
      :style="{ width: width }"
      v-if="bidPriceStatus == '2' && bidFlag == '1'"
    >
      <!-- 再次上报 -->
      <el-button
        type="text"
        icon="icon-ccui-agree"
        @click="reportAgain"
        :disabled="tableBid.length == 0"
        >{{ $t("page.content.reportAgain") }}</el-button
      >
    </div>
  </div>
</template>

<script>
import { getPreviewUrl } from "@/basa/utils";
import {
  qrySupBidDetailSub,
  qryBidPricePrepareSub,
  dealSupBidPriceSub,
  qryBidSchemeProcessStatusSub,
  qrySupRoundPriceHisSub,
  queryPurchaseSchemeDetailSub,
  qryFileinfoListSub
  // qrySupBidDetailForFwa,
  // dealSupBidPriceForFwa
} from "@/app/myProjects/api/myProjectsEl.js";
// import { qryFileinfoList } from "@/app/myProjects/api/myProjects.js";
import tableBid from "../components/tableBidSub";
// import tableQuo from "../components/tableQuo";
import { addUrlPerFix } from "@/basa/utils";
import userList from "../components/userList.vue";
import attachmentUpload from "@/basa/components/common/attachmentUploadSub.vue";
import { setInterval, clearInterval } from "timers";
import BigNumber from "bignumber.js";
export default {
  components: {
    attachmentUpload,
    tableBid,
    userList
    // tableQuo
  },
  mounted() {
    console.log("15115151");
    this.width = this.$refs["detailBody"].scrollWidth + "px";

    this.agentId = this.$router.history.current.query.a;
    this.schemeId = sessionStorage.getItem("schemeId");
    this.supCode = sessionStorage.getItem("subcontractorCode");
    this.getState();
  },
  activated() {
    // this.flagCom = this.$route_query.flagCom ? this.$route_query.flagCom : 1;
  },
  data() {
    return {
      agentId: "",
      active1: "0",
      active2: "0",
      active3: "0",
      active4: "0",
      schemeId: "",
      width: "1000px",
      timeId: "", //定时器
      date3: 0, //时间判断
      supCode: "",
      flagCom: 1, //是否竞争性
      flag: "",
      tableUpData: [], //附件信息
      tableBid: [], //包件信息
      dialogTableVisibletextarea: false,
      dialogHistory: false,
      sscNoticeBO: {},
      packNameList: [],
      total: 0,
      bidFlag: "", //0未投标 1 已投标
      bidPriceStatus: "", // 0:未开始 1:已结束 2:进行中 3:无法查看
      totalCapitalize: "",
      purchaseType: "", //区分方案类型
      bidPriceId: "", //报价id,
      supQuoteId: "", //供应商报价ID
      noticeStatus: "",
      subPackageFlag: "",
      // 附件列表
      tableChangeHistoryHead: [
        { label: this.$t("page.content.name"), prop: "fileName" }, //附件名称
        { label: this.$t("page.content.Description"), prop: "fileSumm" }, //附件说明
        {
          label: this.$t("page.content.operation"),
          prop: "option",
          width: "100",
          slot: this.$t("page.content.operation")
        } //操作
      ],
      tableChangeHistoryData: [],
      tableHistoryData: [],
      // 附件列表
      tableFileData: [],
      tableFileHead: [
        { label: this.$t("page.content.name"), prop: "fileName" }, //附件名称
        { label: this.$t("page.content.Description"), prop: "fileSumm" }, //附件说明
        {
          label: this.$t("page.content.operation"),
          prop: "option",
          width: "60",
          slot: this.$t("page.content.operation")
        } //下载
      ],
      spanWidth: 200,
      unit: "",
      totalPrice: 0, //报价总金额
      active: "0",
      sscPurchaseFileBOS: [], //附近信息
      fixedTax: 0, // 1投标方自行报价、2-只固定税票类型、3-固定税票类型及税率 4-按包件报价
      invoiceType: 0, //发票类型1-增值税普票、2-增值税专票、51-增值税电子普票）
      isUnitPriceTax: 3, //单价报价类型0不含税，1含税
      isTaxAmount: 3, //0否1是是否显示税额
      bidPriceOptions: [],
      btnDisabled: false
    };
  },
  destroyed() {
    if (this.timeId) {
      clearInterval(this.timeId);
    }
  },
  updated() {
    if (this.$refs.groupTitle) {
      this.spanWidth =
        this.$refs.groupTitle.$el.getElementsByClassName("group-title")[0]
          .clientWidth + 20;
    }
  },
  methods: {
    //获取报价总金额
    setTotalPrice(val) {
      // this.totalPrice = this.smalltoBIG(val);
      this.totalPrice = val;
    },
    //获取包件的附件信息
    setFileUploadData(val) {
      let num = Number(this.active);
      this.sscPurchaseFileBOS[num].data = val;
    },
    // 公告详情
    getState() {
      let obj = {
        isShowexeTime: false,
        isShowTag: false,
        isShowLeftTime: false,
        isShowCouTime: false
      };
      this.$store.commit("edit", obj);
      let param = {};
      Object.assign(
        param,
        { schemeId: this.schemeId },
        { agentId: this.agentId },
        { purStep: this.$route_query.purStep }
      );
      qryBidSchemeProcessStatusSub(param).then(res => {
        if (res) {
          // this.flag = 3;
          this.flag = res.data.data.exeStatus;
          if (
            this.flag == 1 ||
            this.flag == 3 ||
            this.flag == 0 ||
            this.flag == 4
          ) {
            this.queryPurchaseSchemeDetail();
          }
        }
      });
    },
    queryPurchaseSchemeDetail() {
      queryPurchaseSchemeDetailSub({
        schemeId: this.schemeId,
        agentId: this.agentId //后期菜单获取
      }).then(res => {
        if (res) {
          this.purchaseType = res.data.data.purchaseType;
          this.subPackageFlag = res.data.data.subPackageFlag;
          sessionStorage.setItem(
            "subPackageFlag",
            res.data.data.subPackageFlag
          );
          this.unit = res.data.data.unit;
          this.init();
        }
      });
    },
    init(isHistory) {
      this.bidPriceOptions = [];
      let param = {};
      Object.assign(
        param,
        { schemeId: this.schemeId },
        { supCode: this.supCode },
        { purStep: this.$route_query.purStep }, //后期菜单获取
        { agentId: this.agentId },
        { bidPriceId: this.bidPriceId } //报价id
      );
      if (isHistory == 1) {
        param.isHistory = 1;
      }
      qrySupBidDetailSub(param).then(res => {
        if (res) {
          this.bidFlag = res.data.data.bidFlag;
          this.bidPriceStatus = res.data.data.bidPriceStatus;
          this.totalPrice = new BigNumber(
            res.data.data.sscSupBidPrepareBO.totalPriceAmount
              ? res.data.data.sscSupBidPrepareBO.totalPriceAmount
              : 0
          ).toFixed(8);
          this.fixedTax = res.data.data.sscSupBidPrepareBO.taxQuotationMethod; //税费报价方式
          if (res.data.data.sscSupBidPrepareBO.taxQuotationMethod !== 4) {
            this.invoiceType = res.data.data.sscSupBidPrepareBO.invoiceType; //发票类型1-增值税普票、2-增值税专票、51-增值税电子普票）
          }
          this.isTaxAmount = res.data.data.sscSupBidPrepareBO.isTaxAmount; //0否1是是否显示税额
          this.isUnitPriceTax = res.data.data.sscSupBidPrepareBO.isUnitPriceTax; //单价报价类型0不含税，1含税
          this.supQuoteId = res.data.data.sscSupBidPrepareBO.supQuoteId; //供应国报价信息
          this.qryFileinfoList1(res.data.data.sscSupBidPrepareBO.bidPriceId);
          this.sscNoticeBO = {
            noticeTitle: res.data.data.sscSupBidPrepareBO.projectTitle,
            textInfo: res.data.data.sscSupBidPrepareBO.projectText
          };
          if (this.bidFlag == 2) {
            let obj = {
              leftTime: "2020-12-12 :00:00:00",
              cutTime: "",
              leftName: this.$t("page.content.RemainingTime"), //投标剩余时间
              cutName: this.$t("page.content.Deadlineforsubmissionofbids"), //投标截止时间
              isShowexeTime: false,
              isShowTag: false,
              isShowLeftTime: true,
              isShowCouTime: true
            };
            if (
              this.purchaseType == 1 ||
              this.purchaseType == 4 ||
              this.purchaseType == 7 ||
              this.purchaseType == 8
            ) {
              obj.leftName = this.$t("page.content.RemainingTime1"); //响应剩余时间
              obj.cutName = this.$t(
                "page.content.Deadlineforsubmissionofbids1"
              ); //响应结束时间
            }
            this.$store.commit("edit", obj);
          } else if (this.bidFlag != 2 || this.bidFlag != 3) {
            let sscSupBidPrepareBO = res.data.data.sscSupBidPrepareBO;
            if (this.bidPriceId == "") {
              this.bidPriceId = sscSupBidPrepareBO.bidPriceId;
            }

            if (sscSupBidPrepareBO.endTime) {
              let vals = new Date(
                sscSupBidPrepareBO.endTime.replace(/-/g, "/")
              );
              var date2 = new Date(); //结束时间
              this.date3 = vals.getTime() - date2.getTime(); //时间差的毫秒数
              if (this.date3 > 1000) {
                this.date3 = Math.floor(this.date3 / 1000);
                this.timeId = setInterval(() => {
                  this.date3--;
                }, 1000);
              } else {
                // this.bidFlag = 5; //时间已结束 不能输入
              }
              let obj = {
                leftTime: sscSupBidPrepareBO.endTime,
                cutTime: sscSupBidPrepareBO.endTime,
                leftName: this.$t("page.content.RemainingTime"), //投标剩余时间
                cutName: this.$t("page.content.Deadlineforsubmissionofbids"), //投标截止时间
                isShowexeTime: false,
                isShowTag: false,
                isShowLeftTime: false,
                isShowCouTime: false
              };
              if (
                this.purchaseType == 1 ||
                this.purchaseType == 4 ||
                this.purchaseType == 7 ||
                this.purchaseType == 8
              ) {
                obj.leftName = this.$t("page.content.RemainingTime1"); //响应剩余时间
                obj.cutName = this.$t(
                  "page.content.Deadlineforsubmissionofbids1"
                ); //响应结束时间
              }
              if (this.bidPriceStatus !== "0") {
                obj.isShowLeftTime = true;
                obj.isShowCouTime = true;
              }
              if (this.bidFlag == 1) {
                obj.isShowLeftTime = true;
                obj.isShowCouTime = true;
                obj.isShowTag = true;
                obj.TagName = this.$t("page.content.Submitted2"); //已报价
              }

              this.$store.commit("edit", obj);
              if (res.data.data.sscBidPackMatInfoBOS.length > 0) {
                res.data.data.sscBidPackMatInfoBOS.forEach((i, index) => {
                  if (i.otherPersons && i.otherPersons.length > 0) {
                    i.otherPersons.forEach(row => {
                      row.cardType = 0;
                    });
                  }
                  if (i.projectPersons && i.projectPersons.length > 0) {
                    i.projectPersons.forEach(row => {
                      row.cardType = 0;
                    });
                  }
                  if (i.securityPersons && i.securityPersons.length > 0) {
                    i.securityPersons.forEach(row => {
                      row.cardType = 0;
                    });
                  }
                  if (i.techPersons && i.techPersons.length > 0) {
                    i.techPersons.forEach(row => {
                      row.cardType = 0;
                    });
                  }
                  let listData = i.sscBidMatInfoBOS;
                  if (listData.length) {
                    listData.forEach(item1 => {
                      let count = listData.filter(i => {
                        return (
                          i.engerCode.substr(0, item1.engerCode.length + 1) ===
                            item1.engerCode + "-" &&
                          i.engerCode !== item1.engerCode
                        );
                      }).length;
                      console.log("res----count", count);
                      if (count > 0) {
                        item1.isParent = true;
                      } else {
                        item1.isParent = false;
                      }
                    });
                  }
                  i.sscBidMatInfoBOS.forEach((bb, index) => {
                    bb.convPriceAmount =
                      bb.convPriceAmount === "" || bb.convPriceAmount === null
                        ? ""
                        : Number(bb.convPriceAmount).toFixed(8);
                    bb.taxAmount =
                      bb.taxAmount === "" || bb.taxAmount === null
                        ? ""
                        : Number(bb.taxAmount).toFixed(8);
                    bb.priceAmount =
                      bb.priceAmount === "" || bb.priceAmount === null
                        ? ""
                        : Number(bb.priceAmount).toFixed(8);
                    bb.taxPriceAmount =
                      bb.taxPriceAmount === "" || bb.taxPriceAmount === null
                        ? ""
                        : Number(bb.taxPriceAmount).toFixed(8);
                    bb.taxConvPriceAmount =
                      bb.taxConvPriceAmount === "" ||
                      bb.taxConvPriceAmount === null
                        ? ""
                        : Number(bb.taxConvPriceAmount).toFixed(8);

                    bb.id = index + 1;
                    i["isBid"] = false;
                    if (
                      res.data.data.sscSupBidPrepareBO.taxQuotationMethod == 3
                    ) {
                      bb.tax = res.data.data.sscSupBidPrepareBO.tax;
                      bb.taxName = res.data.data.sscSupBidPrepareBO.taxStr;
                    } else if (
                      res.data.data.sscSupBidPrepareBO.taxQuotationMethod == 4
                    ) {
                      if (i.taxQuotationMethod == 3) {
                        bb.tax = i.tax;
                        bb.taxName = i.taxStr;
                      }
                    }
                  });

                  let obj = {
                    id: index + 1,
                    packId: i.packId,
                    packName: i.packName,
                    data:
                      i.sscPurchaseFileBOS.length > 0
                        ? i.sscPurchaseFileBOS
                        : []
                  };
                  //报价小计
                  i.sscBidMatInfoBOS.unshift({
                    id: window.$t("page.content.quotationSubtotal"),
                    engerCode: window.$t("page.content.quotationSubtotal"),
                    quantities: 0, //工程量
                    taxConvPriceAmount: 0, //含税单价
                    convPriceAmount: 0, //不含税单价
                    priceAmount: i.packNoTaxPriceAmount, //不含税合价
                    taxPriceAmount: i.packPriceAmount, //含税合价
                    taxAmount: i.packTaxAmount, //税额
                    totalType: 1
                  });

                  this.sscPurchaseFileBOS.push(obj);
                });
              }
              if (this.bidFlag == 1 || this.subPackageFlag == 0) {
                if (this.subPackageFlag != 0) {
                  res.data.data.sscBidPackMatInfoBOS.forEach(i => {
                    if (
                      i.packPriceAmount === "" ||
                      i.packPriceAmount === null
                    ) {
                      i.isBid = false;
                    } else {
                      i.isBid = true;
                    }
                  });
                } else {
                  res.data.data.sscBidPackMatInfoBOS.forEach(i => {
                    i.isBid = true;
                  });
                }
                this.tableBid = res.data.data.sscBidPackMatInfoBOS;
              } else {
                res.data.data.sscBidPackMatInfoBOS.forEach(i => {
                  i.isBid = false;
                });
                this.tableBid = res.data.data.sscBidPackMatInfoBOS;
              }
              this.tableUpData = res.data.data.sscPurchaseFileBOS;
            }
          }
          let sscBidPriceHisBOS = res.data.data.sscBidPriceHisBOS;
          sscBidPriceHisBOS = sscBidPriceHisBOS.reverse();
          if (sscBidPriceHisBOS.length > 0) {
            sscBidPriceHisBOS.forEach((item, index) => {
              // if (this.bidPriceId == item.bidPriceId) {
              //   this.sscNoticeBO = {
              //     noticeTitle: res.data.data.projectTitle,
              //     textInfo: res.data.data.projectText
              //   };
              // }
              let obj = {
                value: "",
                label: ""
              };
              obj.value = item.bidPriceId;
              //第  轮报价
              obj.label =
                window.$t("page.content.this") +
                (index + 1) +
                window.$t("page.content.roundOffer");
              this.bidPriceOptions.push(obj);
            });
          }
        }
      });
    },
    //公告详情
    getNoticeDetail() {
      let param = {};
      Object.assign(
        param,
        { schemeId: this.schemeId },
        { agentId: this.agentId },
        { purStep: this.$route_query.purStep }
      );
      qryBidPricePrepareSub(param).then(res => {
        if (res) {
          if (res.data.data) {
            this.qryFileinfoList1(res.data.data.bidPriceId);
            this.sscNoticeBO = {
              noticeTitle: res.data.data.projectTitle,
              textInfo: res.data.data.projectText
            };
          } else {
            this.sscNoticeBO = {
              noticeTitle: "",
              textInfo: ""
            };
          }
        }
      });
    },
    qryFileinfoList1(bidPriceId) {
      let param = {};
      Object.assign(
        param,
        { supCode: this.supCode },
        { agentId: this.agentId },
        { parentBillId: this.schemeId },
        { billId: bidPriceId },
        // { billType: "0601" },
        // { uploadPhase: "0601" }
        { billType: "1101" },
        { uploadPhase: "1101" }
      );
      qryFileinfoListSub(param).then(res => {
        if (res) {
          this.tableChangeHistoryData = res.data.data;
        }
      });
    },

    //提交
    submit() {
      this.btnDisabled = false;
      let tableData = this.$refs.tableBid.tableData;
      console.log(JSON.parse(JSON.stringify(tableData)), "tableData/////////");
      let tempTableData = []; //报价的包件
      let noPriceTableData = []; //未报价的
      for (let i = 0; i < tableData.length; i++) {
        if (tableData[i].projectPersons.length == 0) {
          //包件  请添加项目负责人！
          return this.$message({
            message:
              window.$t("page.content.packageName") +
              tableData[i].packName +
              window.$t("page.content.pleaseAddProjectLeader"),
            type: "error",
            duration: 3000,
            offset: document.documentElement.clientHeight / 2 - 21
          });
        } else {
          let arr = tableData[i].projectPersons;
          // for (let y = 0; y < arr.length; y++) {
          //   if (
          //     !arr[y].personName ||
          //     !arr[y].personAge ||
          //     (arr[y].cardType != "0" && arr[y].cardType != "2") ||
          //     !arr[y].idCard ||
          //     !arr[y].packPostTitle ||
          //     !arr[y].techPostTitle ||
          //     !arr[y].workYear ||
          //     !arr[y].contctExperYear
          //   ) {
          //     //包件 项目负责人信息未填写完整！
          //     return this.$message({
          //       message:
          //         window.$t("page.content.packageName") +
          //         tableData[i].packName +
          //         window.$t("page.content.projectLeaderNotComplete"),
          //       type: "error",
          //       duration: 3000,
          //       offset: document.documentElement.clientHeight / 2 - 21
          //     });
          //   }
          // }
          for (let y = 0; y < arr.length; y++) {
            if (
              !arr[y].personName ||
              !arr[y].personAge ||
              (arr[y].cardType != "0" && arr[y].cardType != "2") ||
              !arr[y].idCard ||
              !arr[y].packPostTitle ||
              !arr[y].techPostTitle ||
              !arr[y].workYear ||
              !arr[y].contctExperYear
            ) {
              return this.$message({
                message:
                  "包件" + tableData[i].packName + "项目负责人信息未填写完整！",
                type: "error",
                duration: 3000,
                offset: document.documentElement.clientHeight / 2 - 21
              });
            }
            if (arr[y].cardType == 0) {
              let _IDRe18 = /^([1-6][1-9]|50)\d{4}(18|19|20)\d{2}((0[1-9])|10|11|12)(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/;
              let _IDre15 = /^([1-6][1-9]|50)\d{4}\d{2}((0[1-9])|10|11|12)(([0-2][1-9])|10|20|30|31)\d{3}$/;
              // 校验身份证：
              if (
                !_IDRe18.test(arr[y].idCard) &&
                !_IDre15.test(arr[y].idCard)
              ) {
                return this.$message({
                  message:
                    "包件" +
                    tableData[i].packName +
                    "项目负责人证件号码格式不正确！",
                  type: "error",
                  duration: 3000,
                  offset: document.documentElement.clientHeight / 2 - 21
                });
              }
            }

            // if (arr[y].idCard.length < 9) {
            //   return this.$message({
            //     message:
            //       "包件" +
            //       tableData[i].packName +
            //       "项目负责人证件号码格式不正确！",
            //     type: "error",
            //     duration: 3000,
            //     offset: document.documentElement.clientHeight / 2 - 21
            //   });
            // }
          }
        }

        if (tableData[i].techPersons.length == 0) {
          console.log(123);
          //包件 请添加技术负责人！
          // return this.$message({
          //   message:
          //     window.$t("page.content.packageName") +
          //     tableData[i].packName +
          //     window.$t("page.content.pleaseAddLead"),
          //   type: "error",
          //   duration: 3000,
          //   offset: document.documentElement.clientHeight / 2 - 21
          // });
        } else {
          let arr = tableData[i].techPersons;
          // for (let y = 0; y < arr.length; y++) {
          //   if (
          //     !arr[y].personName ||
          //     !arr[y].personAge ||
          //     (arr[y].cardType != "0" && arr[y].cardType != "2") ||
          //     !arr[y].idCard ||
          //     !arr[y].packPostTitle ||
          //     !arr[y].techPostTitle ||
          //     !arr[y].workYear ||
          //     !arr[y].contctExperYear
          //   ) {
          //     //包件 技术负责人信息未填写完整！
          //     return this.$message({
          //       message:
          //         window.$t("page.content.packageName") +
          //         tableData[i].packName +
          //         window.$t("page.content.technicalPersonIsNotComplete"),
          //       type: "error",
          //       duration: 3000,
          //       offset: document.documentElement.clientHeight / 2 - 21
          //     });
          //   }
          // }
          for (let y = 0; y < arr.length; y++) {
            if (
              !arr[y].personName ||
              !arr[y].personAge ||
              (arr[y].cardType != "0" && arr[y].cardType != "2") ||
              !arr[y].idCard ||
              !arr[y].packPostTitle ||
              !arr[y].techPostTitle ||
              !arr[y].workYear ||
              !arr[y].contctExperYear
            ) {
              return this.$message({
                message:
                  "包件" + tableData[i].packName + "技术负责人信息未填写完整！",
                type: "error",
                duration: 3000,
                offset: document.documentElement.clientHeight / 2 - 21
              });
            }
            if (arr[y].cardType == 0) {
              let _IDRe18 = /^([1-6][1-9]|50)\d{4}(18|19|20)\d{2}((0[1-9])|10|11|12)(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/;
              let _IDre15 = /^([1-6][1-9]|50)\d{4}\d{2}((0[1-9])|10|11|12)(([0-2][1-9])|10|20|30|31)\d{3}$/;
              // 校验身份证：
              if (
                !_IDRe18.test(arr[y].idCard) &&
                !_IDre15.test(arr[y].idCard)
              ) {
                return this.$message({
                  message:
                    "包件" +
                    tableData[i].packName +
                    "技术负责人证件号码格式不正确！",
                  type: "error",
                  duration: 3000,
                  offset: document.documentElement.clientHeight / 2 - 21
                });
              }
            }
            // if (arr[y].idCard.length < 9) {
            //   return this.$message({
            //     message:
            //       "包件" +
            //       tableData[i].packName +
            //       "技术负责人证件号码格式不正确！",
            //     type: "error",
            //     duration: 3000,
            //     offset: document.documentElement.clientHeight / 2 - 21
            //   });
            // }
          }
        }
        if (tableData[i].securityPersons.length == 0) {
          //包件 请添加安全负责人！
          return this.$message({
            message:
              window.$t("page.content.packageName") +
              tableData[i].packName +
              window.$t("page.content.pleaseAddSecOfficer"),
            type: "error",
            duration: 3000,
            offset: document.documentElement.clientHeight / 2 - 21
          });
        } else {
          let arr = tableData[i].securityPersons;
          // for (let y = 0; y < arr.length; y++) {
          //   if (
          //     !arr[y].personName ||
          //     !arr[y].personAge ||
          //     (arr[y].cardType != "0" && arr[y].cardType != "2") ||
          //     !arr[y].idCard ||
          //     !arr[y].packPostTitle ||
          //     !arr[y].techPostTitle ||
          //     !arr[y].workYear ||
          //     !arr[y].contctExperYear
          //   ) {
          //     //安全负责人信息未填写完整！
          //     return this.$message({
          //       message:
          //         window.$t("page.content.packageName") +
          //         tableData[i].packName +
          //         window.$t("page.content.securityResIsNotComplete"),
          //       type: "error",
          //       duration: 3000,
          //       offset: document.documentElement.clientHeight / 2 - 21
          //     });
          //   }
          // }
          for (let y = 0; y < arr.length; y++) {
            if (
              !arr[y].personName ||
              !arr[y].personAge ||
              (arr[y].cardType != "0" && arr[y].cardType != "2") ||
              !arr[y].idCard ||
              !arr[y].packPostTitle ||
              !arr[y].techPostTitle ||
              !arr[y].workYear ||
              !arr[y].contctExperYear
            ) {
              return this.$message({
                message:
                  "包件" + tableData[i].packName + "安全负责人信息未填写完整！",
                type: "error",
                duration: 3000,
                offset: document.documentElement.clientHeight / 2 - 21
              });
            }
            if (arr[y].cardType == 0) {
              let _IDRe18 = /^([1-6][1-9]|50)\d{4}(18|19|20)\d{2}((0[1-9])|10|11|12)(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/;
              let _IDre15 = /^([1-6][1-9]|50)\d{4}\d{2}((0[1-9])|10|11|12)(([0-2][1-9])|10|20|30|31)\d{3}$/;
              // 校验身份证：
              if (
                !_IDRe18.test(arr[y].idCard) &&
                !_IDre15.test(arr[y].idCard)
              ) {
                return this.$message({
                  message:
                    "包件" +
                    tableData[i].packName +
                    "安全负责人证件号码格式不正确！",
                  type: "error",
                  duration: 3000,
                  offset: document.documentElement.clientHeight / 2 - 21
                });
              }
            }
            // if (arr[y].idCard.length < 9) {
            //   return this.$message({
            //     message:
            //       "包件" +
            //       tableData[i].packName +
            //       "安全负责人证件号码格式不正确！",
            //     type: "error",
            //     duration: 3000,
            //     offset: document.documentElement.clientHeight / 2 - 21
            //   });
            // }
          }
        }
        if (tableData[i].otherPersons.length > 0) {
          let arr = tableData[i].otherPersons;
          // for (let y = 0; y < arr.length; y++) {
          //   if (
          //     !arr[y].personName ||
          //     !arr[y].personAge ||
          //     (arr[y].cardType != "0" && arr[y].cardType != "2") ||
          //     !arr[y].idCard ||
          //     !arr[y].packPostTitle ||
          //     !arr[y].techPostTitle ||
          //     !arr[y].workYear ||
          //     !arr[y].contctExperYear
          //   ) {
          //     //包件 其他人员信息未填写完整！
          //     return this.$message({
          //       message:
          //         window.$t("page.content.packageName") +
          //         tableData[i].packName +
          //         window.$t("page.content.pleaseAddSecOfficer"),
          //       type: "error",
          //       duration: 3000,
          //       offset: document.documentElement.clientHeight / 2 - 21
          //     });
          //   }
          // }
          for (let y = 0; y < arr.length; y++) {
            if (
              !arr[y].personName ||
              !arr[y].personAge ||
              (arr[y].cardType != "0" && arr[y].cardType != "2") ||
              !arr[y].idCard ||
              !arr[y].packPostTitle ||
              !arr[y].techPostTitle ||
              !arr[y].workYear ||
              !arr[y].contctExperYear
            ) {
              return this.$message({
                message:
                  "包件" + tableData[i].packName + "其他人员信息未填写完整！",
                type: "error",
                duration: 3000,
                offset: document.documentElement.clientHeight / 2 - 21
              });
            }
            if (arr[y].cardType == 0) {
              let _IDRe18 = /^([1-6][1-9]|50)\d{4}(18|19|20)\d{2}((0[1-9])|10|11|12)(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/;
              let _IDre15 = /^([1-6][1-9]|50)\d{4}\d{2}((0[1-9])|10|11|12)(([0-2][1-9])|10|20|30|31)\d{3}$/;
              // 校验身份证：
              if (
                !_IDRe18.test(arr[y].idCard) &&
                !_IDre15.test(arr[y].idCard)
              ) {
                return this.$message({
                  message:
                    "包件" +
                    tableData[i].packName +
                    "其他人员证件号码格式不正确！",
                  type: "error",
                  duration: 3000,
                  offset: document.documentElement.clientHeight / 2 - 21
                });
              }
            }
          }
        }

        let bidNum = 0;
        for (let y = 1; y < tableData[i].sscBidMatInfoBOS.length; y++) {
          // 不校验父级
          if (tableData[i].sscBidMatInfoBOS[y].isLast) {
            if (tableData[i].sscBidMatInfoBOS[y].isBid) {
              // 当前这条清单报价了
              bidNum += 1;
            }
          }
        }
        if (bidNum > 0) {
          tableData[i].isBid = true;
          tableData[i].isSelected = 1;
          tempTableData.push(tableData[i]);
        } else {
          tableData[i].isBid = false;
          tableData[i].isSelected = 0;
          noPriceTableData.push(tableData[i]);
        }
      }
      // tableData.forEach(item => {
      //   if (item.isBid == true) {
      //     //判断是否报价
      //     tempTableData.push(item);
      //   } else {
      //     noPriceTableData.push(item);
      //   }
      // });
      if (this.sscPurchaseFileBOS.length > 0) {
        this.sscPurchaseFileBOS.forEach(item => {
          if (item.data.length > 0) {
            tempTableData.forEach(aa => {
              if (aa.packId == item.packId) {
                aa.sscPurchaseFileBOS = item.data;
              }
            });
            noPriceTableData.forEach(aa => {
              if (aa.packId == item.packId) {
                aa.sscPurchaseFileBOS = item.data;
              }
            });
          }
        });
      }
      if (tempTableData.length > 0) {
        //判断是否填写完整
        let flag = [];
        let tempFileData = []; //判断包件附件是否上传
        let index1 = null;
        let index2 = null;
        if (tempTableData.length > 0) {
          for (let i = 0; i < tempTableData.length; i++) {
            let item = tempTableData[i];
            if (item.sscPurchaseFileBOS.length == 0) {
              tempFileData.push(item);
            }
            for (let j = 0; j < item.sscBidMatInfoBOS.length; j++) {
              if (
                item.sscBidMatInfoBOS[j].totalType !== 1 &&
                !item.sscBidMatInfoBOS[j].isParent
              ) {
                if (
                  (item.sscBidMatInfoBOS[j].taxConvPriceAmount === "" &&
                    item.sscBidMatInfoBOS[j].convPriceAmount === "") ||
                  item.sscBidMatInfoBOS[j].taxName == ""
                ) {
                  index1 = i;
                  index2 = j - 1;
                  flag.push(item.sscBidMatInfoBOS[j]);
                  break;
                }
              }
            }
          }
        }
        let noPriceTableDataFlag = false;
        let noPriacePackName = "";
        for (let i = 0; i < noPriceTableData.length; i++) {
          if (noPriceTableData[i].sscPurchaseFileBOS.length > 0) {
            let item = noPriceTableData[i].sscBidMatInfoBOS;
            for (let j = 0; j < item.length; j++)
              if (item[j].totalType !== 1) {
                if (
                  (item[j].taxConvPriceAmount === "" &&
                    item[j].convPriceAmount === "") ||
                  item[j].taxName == ""
                ) {
                  noPriceTableDataFlag = true;
                  noPriacePackName = noPriceTableData[i].packName;
                  break;
                }
              }
          }
        }

        if (flag.length > 0 && flag[0].totalType !== 1) {
          // this.$message({
          //   message:
          //     this.subPackageFlag == 1
          //       ? `${tempTableData[index1].packName}包件` +
          //         `第${index2 + 1} 行` +
          //         this.$t("page.content.emptyTips")
          //       : `第${index2 + 1} 行` + this.$t("page.content.emptyTips"), //请将数据填写完整
          //   type: "warning",
          //   duration: 3000,
          //   offset: document.documentElement.clientHeight / 2 - 21
          // });
          let message = "";
          if (
            Number(this.isUnitPriceTax) === 0 &&
            flag[0].convPriceAmount === ""
          ) {
            //包件  行不含税单价还未填写
            message =
              this.subPackageFlag == 1
                ? `${tempTableData[index1].packName}${window.$t(
                    "page.content.packageName"
                  )}` +
                  `${window.$t("page.content.the")}${index2 + 1}${window.$t(
                    "page.content.line1"
                  )}`
                : `${window.$t("page.content.the")}${index2 + 1}${window.$t(
                    "page.content.line1"
                  )}`; //请将数据填写完整
          } else if (
            Number(this.isUnitPriceTax) === 1 &&
            flag[0].taxConvPriceAmount === ""
          ) {
            //包件 第 行含税单价还未填写
            message =
              this.subPackageFlag == 1
                ? `${tempTableData[index1].packName}${window.$t(
                    "page.content.packageName"
                  )}` +
                  `${window.$t("page.content.the")}${index2 + 1}${window.$t(
                    "page.content.line2"
                  )}`
                : `${window.$t("page.content.the")}${index2 + 1}${window.$t(
                    "page.content.line2"
                  )}`; //请将数据填写完整
          } else if (!flag[0].taxName) {
            //行税率还未设置，请您重新选择！
            message =
              this.subPackageFlag == 1
                ? `${tempTableData[index1].packName}${window.$t(
                    "page.content.packageName"
                  )}` +
                  `${window.$t("page.content.the")}${index2 + 1} ${window.$t(
                    "page.content.line3"
                  )}`
                : `${window.$t("page.content.the")}${index2 + 1} ${window.$t(
                    "page.content.line3"
                  )}`; //请将数据填写完整
          }
          this.$message({
            message,
            type: "warning",
            duration: 3000,
            offset: document.documentElement.clientHeight / 2 - 21
          });
        } else if (tempFileData.length > 0) {
          for (let i = 0; i < tempFileData.length; i++) {
            if (tempFileData[i].sscPurchaseFileBOS.length == 0) {
              //包件
              this.$message({
                message:
                  this.subPackageFlag == 1
                    ? `${window.$t("page.content.packageName")}${
                        tempFileData[i].packName
                      }` + this.$t("page.content.upload5")
                    : this.$t("page.content.upload5"),
                type: "warning",
                duration: 3000,
                offset: document.documentElement.clientHeight / 2 - 21
              });
              break;
            }
          }
        } else if (noPriceTableDataFlag) {
          // /还未报价
          this.$message({
            message:
              this.subPackageFlag == 1
                ? `${window.$t(
                    "page.content.packageName"
                  )}${noPriacePackName}` +
                  window.$t("page.content.havenQuotedYet")
                : window.$t("page.content.havenQuotedYet"),
            type: "warning",
            duration: 3000,
            offset: document.documentElement.clientHeight / 2 - 21
          });
        } else {
          console.log(tempTableData, "tempTableData");
          console.log(noPriceTableData, "noPriceTableData");
          for (let i = 0; i < tempTableData.length; i++) {
            // if (!tempTableData[i].workMonth) {
            //   return this.$message({
            //     message: "包件" + tempTableData[i].packName + "请输入工期！",
            //     type: "error",
            //     duration: 3000,
            //     offset: document.documentElement.clientHeight / 2 - 21
            //   });
            // }
            if (tempTableData[i].projectPersons.length == 0) {
              return this.$message({
                message:
                  "包件" + tempTableData[i].packName + "请添加项目负责人！",
                type: "error",
                duration: 3000,
                offset: document.documentElement.clientHeight / 2 - 21
              });
            } else {
              let arr = tempTableData[i].projectPersons;
              for (let y = 0; y < arr.length; y++) {
                if (
                  !arr[y].personName ||
                  !arr[y].personAge ||
                  (arr[y].cardType != "0" && arr[y].cardType != "2") ||
                  !arr[y].idCard ||
                  !arr[y].packPostTitle ||
                  !arr[y].techPostTitle ||
                  !arr[y].workYear ||
                  !arr[y].contctExperYear
                ) {
                  return this.$message({
                    message:
                      "包件" +
                      tempTableData[i].packName +
                      "项目负责人信息未填写完整！",
                    type: "error",
                    duration: 3000,
                    offset: document.documentElement.clientHeight / 2 - 21
                  });
                }
              }
            }

            if (tempTableData[i].techPersons.length == 0) {
              console.log(123);

              // return this.$message({
              //   message:
              //     "包件" + tempTableData[i].packName + "请添加技术负责人！",
              //   type: "error",
              //   duration: 3000,
              //   offset: document.documentElement.clientHeight / 2 - 21
              // });
            } else {
              let arr = tempTableData[i].techPersons;
              for (let y = 0; y < arr.length; y++) {
                if (
                  !arr[y].personName ||
                  !arr[y].personAge ||
                  (arr[y].cardType != "0" && arr[y].cardType != "2") ||
                  !arr[y].idCard ||
                  !arr[y].packPostTitle ||
                  !arr[y].techPostTitle ||
                  !arr[y].workYear ||
                  !arr[y].contctExperYear
                ) {
                  return this.$message({
                    message:
                      "包件" +
                      tempTableData[i].packName +
                      "技术负责人信息未填写完整！",
                    type: "error",
                    duration: 3000,
                    offset: document.documentElement.clientHeight / 2 - 21
                  });
                }
              }
            }
            if (tempTableData[i].securityPersons.length == 0) {
              return this.$message({
                message:
                  "包件" + tempTableData[i].packName + "请添加安全负责人！",
                type: "error",
                duration: 3000,
                offset: document.documentElement.clientHeight / 2 - 21
              });
            } else {
              let arr = tempTableData[i].securityPersons;
              for (let y = 0; y < arr.length; y++) {
                if (
                  !arr[y].personName ||
                  !arr[y].personAge ||
                  (arr[y].cardType != "0" && arr[y].cardType != "2") ||
                  !arr[y].idCard ||
                  !arr[y].packPostTitle ||
                  !arr[y].techPostTitle ||
                  !arr[y].workYear ||
                  !arr[y].contctExperYear
                ) {
                  return this.$message({
                    message:
                      "包件" +
                      tempTableData[i].packName +
                      "安全负责人信息未填写完整！",
                    type: "error",
                    duration: 3000,
                    offset: document.documentElement.clientHeight / 2 - 21
                  });
                }
              }
            }
            if (tempTableData[i].otherPersons.length > 0) {
              let arr = tempTableData[i].otherPersons;
              for (let y = 0; y < arr.length; y++) {
                if (
                  !arr[y].personName ||
                  !arr[y].personAge ||
                  (arr[y].cardType != "0" && arr[y].cardType != "2") ||
                  !arr[y].idCard ||
                  !arr[y].packPostTitle ||
                  !arr[y].techPostTitle ||
                  !arr[y].workYear ||
                  !arr[y].contctExperYear
                ) {
                  return this.$message({
                    message:
                      "包件" +
                      tempTableData[i].packName +
                      "其他人员信息未填写完整！",
                    type: "error",
                    duration: 3000,
                    offset: document.documentElement.clientHeight / 2 - 21
                  });
                }
              }
            }
          }
          this.packNameList = tempTableData;
          // this.tableList = tempTableData;
          this.tableList = [...tempTableData, ...noPriceTableData];
          this.dialogTableVisibletextarea = true;
          this.isSure = false;
        }
      } else {
        this.$message({
          message: this.$t("page.content.leaseOne2"), //最少报价一件包件
          type: "warning",
          duration: 3000,
          offset: document.documentElement.clientHeight / 2 - 21
        });
        return false;
      }
    },
    sure() {
      this.btnDisabled = true;
      if (this.date3 <= 0) {
        if (this.timeId) {
          clearInterval(this.timeId);
        }
        this.$confirm(
          this.$t("page.content.dialogTips1"),
          this.$t("page.content.tip"),
          {
            distinguishCancelAndClose: true,
            showCancelButton: false,
            confirmButtonText: this.$t("page.content.sure1"), //确定
            //取消
            customClass: "ccui-message-box-custom"
          }
        ).then(() => {
          this.getState();
        });
      } else {
        // 投标附件
        let tempFileData = [];
        if (this.sscPurchaseFileBOS.length > 0) {
          this.sscPurchaseFileBOS.forEach(item => {
            if (item.data.length > 0) {
              tempFileData.push(item);
            }
          });
        }
        let paramss = {};
        Object.assign(
          paramss,
          { schemeId: this.schemeId },
          { supCode: this.supCode },
          { purStep: this.$route_query.purStep }, //后期菜单获取
          { agentId: this.agentId },
          { bidPriceId: this.bidPriceId } //报价id
        );
        paramss.isHistory = 1;
        paramss.isShowLoading = true;
        qrySupBidDetailSub(paramss)
          .then(res => {
            if (res) {
              let priceStatus = res.data.data.sscSupBidPrepareBO.priceStatus;
              if (priceStatus == 3) {
                this.$confirm(
                  this.$t("page.content.dialogTips2"),
                  this.$t("page.content.tip"),
                  {
                    distinguishCancelAndClose: true,
                    showCancelButton: false,
                    confirmButtonText: this.$t("page.content.sure1"), //确定
                    //取消
                    customClass: "ccui-message-box-custom"
                  }
                ).then(() => {
                  this.$router.back();
                });
              } else {
                let param = {};
                let tableList1 = [];
                let totalNoTaxPriceAmount = new BigNumber(0);
                let totalTaxAmount = new BigNumber(0);
                this.tableList.forEach(item => {
                  let obj = {};
                  obj.supJoinId = item.supJoinId;
                  obj.packId = item.packId;
                  obj.isSelected = item.isSelected;
                  obj.packName = item.packName;

                  // 新加的技术人员信息
                  obj.projectPersons = item.projectPersons;
                  obj.techPersons = item.techPersons;
                  obj.securityPersons = item.securityPersons;
                  obj.otherPersons = item.otherPersons;

                  let sscBidMatPriceInfoBOS = [];
                  tempFileData.forEach(aa => {
                    if (aa.packId == item.packId) {
                      obj.FileInfoBOs = aa.data;
                    }
                  });
                  item.sscBidMatInfoBOS.forEach((aItem, index) => {
                    if (index > 0) {
                      let priceAmount;
                      if (
                        aItem.priceAmount === "" ||
                        aItem.priceAmount === null ||
                        aItem.priceAmount === undefined
                      ) {
                        priceAmount = 0;
                      } else {
                        priceAmount = aItem.priceAmount;
                      }
                      let priceAmounts;
                      if (
                        aItem.taxAmount === "" ||
                        aItem.taxAmount === null ||
                        aItem.taxAmount === undefined
                      ) {
                        priceAmounts = 0;
                      } else {
                        priceAmounts = aItem.taxAmount;
                      }
                      totalNoTaxPriceAmount = totalNoTaxPriceAmount.plus(
                        new BigNumber(priceAmount)
                      );
                      totalTaxAmount = totalTaxAmount.plus(
                        new BigNumber(priceAmounts)
                      );
                      let tt = {
                        schemeMatId: aItem.engerId, //工程量清单ID
                        convPriceAmount:
                          aItem.convPriceAmount === "" ||
                          aItem.convPriceAmount === null
                            ? ""
                            : new BigNumber(aItem.convPriceAmount).toFixed(8), //不含税单价
                        taxConvPriceAmount:
                          aItem.taxConvPriceAmount === "" ||
                          aItem.taxConvPriceAmount === null
                            ? ""
                            : new BigNumber(aItem.taxConvPriceAmount).toFixed(
                                8
                              ), //含税单价
                        priceAmount:
                          aItem.priceAmount === 0 ||
                          aItem.priceAmount === "0.00" ||
                          aItem.priceAmount == ""
                            ? ""
                            : new BigNumber(aItem.priceAmount).toFixed(8), //不含税金额
                        taxPriceAmount:
                          aItem.taxPriceAmount === 0 ||
                          aItem.taxPriceAmount === "0.000" ||
                          aItem.taxPriceAmount == ""
                            ? ""
                            : new BigNumber(aItem.taxPriceAmount).toFixed(8), //含税金额
                        taxAmount:
                          aItem.taxAmount === null ||
                          aItem.taxAmount === undefined ||
                          aItem.taxAmount === ""
                            ? ""
                            : new BigNumber(aItem.taxAmount).toFixed(8), //税额
                        tax: aItem.tax, //税率
                        taxName: aItem.taxName, //税率名称
                        // invoiceType: aItem.invoiceType, //税率类型
                        quantities: aItem.quantities //工程量
                      };
                      if (this.fixedTax == 3) {
                        tt.invoiceType = this.invoiceType;
                      } else {
                        tt.invoiceType = aItem.invoiceType;
                      }
                      sscBidMatPriceInfoBOS.push(tt);
                    }
                  });
                  obj.sscBidMatPriceInfoBOS = sscBidMatPriceInfoBOS;
                  tableList1.push(obj);
                });
                Object.assign(
                  param,
                  { schemeId: this.schemeId },
                  { supCode: this.supCode },
                  { purStep: this.$route_query.purStep }, //后期动态菜单后更换
                  { agentId: this.agentId },
                  { bidPriceId: this.bidPriceId },
                  { sscBidPackMatPriceInfoBOS: tableList1 },
                  {
                    totalPriceAmount: new BigNumber(this.totalPrice).toFixed(3)
                  }, //报价总金额
                  {
                    totalNoTaxPriceAmount: totalNoTaxPriceAmount
                      .toFormat()
                      .split(",")
                      .join("")
                  }, //报价不含税总金额
                  {
                    totalTaxAmount: totalTaxAmount
                      .toFormat()
                      .split(",")
                      .join("")
                  }, //报价总税额
                  { requestLimit: true } //防止多次点击
                );
                param.isShowLoading = true;
                dealSupBidPriceSub(param)
                  .then(res => {
                    if (res) {
                      this.sscPurchaseFileBOS = [];
                      this.dialogTableVisibletextarea = false;
                      this.getState();
                      this.$message({
                        message: this.$t("page.content.successfully"), //投标成功
                        type: "success",
                        duration: 3000,
                        offset: document.documentElement.clientHeight / 2 - 21
                      });
                      this.isSure = true;
                    }
                  })
                  .catch(() => {
                    this.btnDisabled = false;
                  });
              }
            }
          })
          .catch(() => {
            this.btnDisabled = false;
          });
      }
    },
    handleCacal() {
      this.$router.back();
    },
    openHistory() {
      this.dialogHistory = true;
      this.qrySupRoundPriceHis();
    },
    //再次上报
    reportAgain() {
      this.btnDisabled = false;
      let paramss = {};
      Object.assign(
        paramss,
        { schemeId: this.schemeId },
        { supCode: this.supCode },
        { purStep: this.$route_query.purStep }, //后期菜单获取
        { agentId: this.agentId }
      );
      qrySupBidDetailSub(paramss).then(res => {
        if (res) {
          if (res.data.data.bidFlag !== "3") {
            this.bidFlag = "0";
            let _that = this;
            _that.$nextTick(() => {
              _that.$refs.tableBid.refData();
            });
          } else {
            this.bidFlag = res.data.data.bidFlag;
          }
        }
      });
    },
    //历史报价
    qrySupRoundPriceHis() {
      let param = {};
      Object.assign(
        param,
        { schemeId: this.schemeId },
        { supCode: this.supCode },
        { agentId: this.agentId }
      );
      qrySupRoundPriceHisSub(param).then(res => {
        if (res) {
          this.tableHistoryData = [];
          res.data.data.forEach(v => {
            if (v.purStep == this.$route_query.purStep) {
              this.tableHistoryData.push(v);
            }
          });
          if (this.tableHistoryData.length > 0) {
            this.tableHistoryData.forEach(item => {
              let param = {};
              Object.assign(
                param,
                { supCode: this.supCode },
                { agentId: this.agentId },
                { parentBillId: this.schemeId },
                { billId: item.supQuoteId },
                { billType: "0603" },
                { uploadPhase: "0603" }
              );
              qryFileinfoListSub(param).then(res => {
                if (res) {
                  this.$set(item, "tableFileData", res.data.data);
                }
              });
            });
          }
        }
      });
    },
    downloadUrlFile(row) {
      let openUrl = document.createElement("a");
      openUrl.style.display = "none";
      openUrl.href = `${addUrlPerFix(
        process.env.VUE_APP_BASE_URL
      )}/apis/bid-scp/oss/downloadByUploadId?uploadId=${row.uploadId}`;
      openUrl.setAttribute("download", row.fileName);
      document.body.appendChild(openUrl);
      openUrl.click();
    },
    /** 数字金额大写转换(可以处理整数,小数,负数) */

    smalltoBIG(n) {
      var fraction = ["角", "分"];
      var digit = ["零", "壹", "贰", "叁", "肆", "伍", "陆", "柒", "捌", "玖"];
      var unit = [
        ["元", "万", "亿"],
        ["", "拾", "佰", "仟"]
      ];
      var head = n < 0 ? "负" : "";
      n = Math.abs(n);

      var s = "";

      for (var i = 0; i < fraction.length; i++) {
        s += (
          digit[
            Math.floor(
              window.$computeUtil.getMultiply(n, 10, Math.pow(10, i))
            ) % 10
          ] + fraction[i]
        ).replace(/零./, "");
      }
      s = s || "整";
      n = Math.floor(n);

      for (var k = 0; k < unit[0].length && n > 0; k++) {
        var p = "";
        for (var j = 0; j < unit[1].length && n > 0; j++) {
          p = digit[n % 10] + unit[1][j] + p;
          n = Math.floor(n / 10);
        }
        s = p.replace(/(零.)*零$/, "").replace(/^$/, "零") + unit[0][k] + s;
      }
      return (
        head +
        s
          .replace(/(零.)*零元/, "元")
          .replace(/(零.)+/g, "零")
          .replace(/^整$/, "零元整")
      );
    },
    //更改下拉历史报价
    changeBidPrice() {
      this.init(1);
    },
    //预览
    preview({ fileUrl }) {
      getPreviewUrl(fileUrl);
      //const previewSrc = getPreviewUrl(fileUrl);
      //window.open(previewSrc);
    }
  }
};
</script>

<style lang="scss" scoped>
.tip {
  padding-left: 20px;
  color: #4a4a4a;
  font-size: 13px;
  .tip-title {
    margin-bottom: 20px;
  }
}
.noBegin {
  display: flex;
  justify-content: center;
  height: 500px;
  align-items: center;
  font-size: 18px;
  color: #4a4a4a;
}
.noBuy {
  .el-alert--info.is-light {
    color: #0089ef;
    background-color: #e6f7ff;
  }
}
.upFile {
  margin-top: 15px;
  position: relative;
  span {
    position: absolute;
    top: 0px;
    left: 100px;
    color: #999999;
  }
}
.dialogBid {
  width: 400px;
  display: flex;
  flex-direction: column;
  align-items: center;
  p {
    line-height: 25px;
  }
}
.tableDownload {
  padding: 15px 0;
}
.operate {
  position: fixed;
  width: calc(100% - 270px);
  bottom: 20px;
  z-index: 299;
  height: 40px;
  background: rgba(76, 76, 76, 0.8);
  text-align: center;
  .el-button {
    color: white;
  }
}
.historyBox {
  // max-height: 400px;
  .quotation {
    border: 1px solid #eeeeee;
    width: 100%;
    margin-bottom: 15px;
    .quotationTitle {
      line-height: 40px;
      background-color: #e6f7ff;
      color: #0089ef;
      border-bottom: 1px solid #eeeeee;
      padding-left: 20px;
      span {
        margin-left: 15px;
      }
    }
    .quotationInfo {
      line-height: 40px;
      padding-left: 20px;
      border-bottom: 1px solid #eeeeee;
      font-weight: bold;
    }
    .quotationMoney {
      margin-top: 20px;
      padding-left: 20px;
      span {
        color: #ff142f;
        font-weight: bold;
      }
    }
    .quotationTabel {
      padding: 0px 40px;
    }
  }
  /deep/ .el-tabs__customize > .el-tabs__header {
    margin-bottom: 20px !important;
    padding-top: 10px !important;
  }
}

.noBuyTop {
  position: relative;
  .priceBox {
    position: absolute;
    top: 5px;
    left: 66px;
    font-size: 14px;
  }
}
.historyPrice {
  margin-bottom: 20px;
  .title {
    font-size: 14px;
  }
}
</style>
